import { useNavigate } from "react-router-dom";
import { useState, useRef, useMemo, useCallback } from "react";
import { CallApiAdminSignIn } from "../Api/Enforcement";
import { adminVerify } from "../Api/SubUrl";
import {
  handleSetPass,
  handleSetTmpToken,
} from "../Share/Func/Storage";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ShowCustomErrorModal } from "../Components/Atoms/CustomErrorModal";
export default function useAdminLoginPage() {
  let navigate = useNavigate();

  const reCaptchaV2 = useRef();
  const [loading, setLoading] = useState(false);

  const signInSchemaForm = yup.object().shape({
    userName: yup.string().required("Vui lòng nhập tên tài khoản"),
    password: yup.string().required("Vui lòng nhập mật khẩu"),
  });

  const { control, handleSubmit } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: useMemo(
      () => ({
        userName: "",
        password: "",
      }),
      []
    ),
    resolver: yupResolver(signInSchemaForm),
  });

  const handleLogin = async (formData) => {
    if (loading) return;

    setLoading(true);

    const token = {
      token_v2: reCaptchaV2.current.getValue() ?? "",
      token_v3: "",
    };

    if (!token.token_v2) {
      ShowCustomErrorModal({
        message: "Vui lòng xác thực reCAPTCHA!",
        title: "Đã xảy ra lỗi",
      });
      return;
    }

    CallApiAdminSignIn(token, formData, (res) => {
      setLoading(false);
      reCaptchaV2.current.reset();
      if (res.Status !== undefined) {
        ShowCustomErrorModal({
          message: res.Status.data.Message,
          title: "Đăng nhập thất bại",
        });
      } else {
        handleSetPass(formData.password);
        handleSetTmpToken(res.tmpToken);
        navigate(adminVerify);
      }
    });
  };
  const handleInvalid = useCallback((errors) => {
    const errorMessages = Object.values(errors)
      .map((err) => `<p>${err.message}</p>`)
      .join("");
    ShowCustomErrorModal({ message: errorMessages });
  }, []);
  return {
    loading,
    reCaptchaV2,
    control,
    handleSubmit: handleSubmit(handleLogin, handleInvalid),
  };
}
